<template>
  <v-container>
    <jti-expansion-panel panelName="Schedule Details">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container grid-list-lg>
          <v-dialog
            ref="dialog"
            v-model="dateFromModal"
            :return-value.sync="dateFrom"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFrom"
              label="Date From"
              prepend-icon="event"
              readonly
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-date-picker
              v-model="dateFrom"
              scrollable
              :min="new Date().toISOString().substr(0, 10)"
              :max="dateTo"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="dateFromModal = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialog.save(dateFrom)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>

          <v-dialog
            ref="dialogs"
            v-model="dateToModal"
            :return-value.sync="dateTo"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateTo"
              label="Date To"
              prepend-icon="event"
              readonly
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-date-picker v-model="dateTo" scrollable :min="dateFrom">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="dateToModal = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialogs.save(dateTo)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>

          <v-select
            label="Select Day"
            :items="day"
            v-model="selectedDay"
            prepend-icon="event"
            required
            :rules="[rules.required]"
          ></v-select>

          <v-dialog
            ref="timeDialog"
            v-model="timeDialog"
            :return-value.sync="actualTime"
            @keydown.enter="timeDialog = false"
            @keydown.esc="timeDialog = false"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="actualTime"
              label="Time"
              prepend-icon="access_time"
              readonly
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-time-picker
              v-if="timeDialog"
              v-model="actualTime"
              id="time"
              full-width
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="timeDialog = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.timeDialog.save(actualTime)"
                >OK</v-btn
              >
            </v-time-picker>
          </v-dialog>

          <v-select
            v-model="data.fare_matrix_id"
            label="Fare Matrix"
            :items="fareMatrix"
            :readonly="readonly"
            return-object
            required
            :rules="[rules.required]"
          ></v-select>

          <v-select
            v-model="data.terminal_server_id"
            label="Terminal Server"
            :items="terminalServers"
            :readonly="readonly"
            required
            :rules="[rules.required]"
          ></v-select>
        </v-container>
      </v-form>
    </jti-expansion-panel>

    <v-snackbar :timeout="timeout" bottom right v-model="snackbar">
      {{ totalCount }} Schedule(s) will be created.
      <v-btn flat color="pink" @click.native="snackbar = false">X</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
const now = new Date();

export default {
  props: {
    data: Object,
    readonly: Boolean,
    fareMatrix: Array,
    terminalServers: Array,
  },
  computed: {
    computedData() {
      const selectedDate = [];

      var dateFrom = Date.parse(this.dateFrom);
      var dateTo = Date.parse(this.dateTo);

      dateFrom = dateFrom - 86400000;

      for (var i = dateFrom; i < dateTo; ) {
        i = i + 86400000;
        var day = this.$dateFormat(i, "dddd").toLowerCase();

        console.log(day);

        if (this.selectedDay === day) {
          var date = {
            departure_date_time:
              this.$dateFormat(i, "YYYY-MM-DD") + " " + this.actualTime + ":00",
          };
          selectedDate.push(date);
        } else if (this.selectedDay === "everyday") {
          var dates = {
            departure_date_time:
              this.$dateFormat(i, "YYYY-MM-DD") + " " + this.actualTime + ":00",
          };
          selectedDate.push(dates);
        }
      }
      return {
        dates: selectedDate,
        fare_matrix: this.data.fare_matrix_id,
        terminal_server_id: this.data.terminal_server_id,
      };
    },
    totalCount() {
      this.snackbar = true;
      return this.computedData.dates.length;
    },
  },
  data() {
    return {
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      day: [
        { text: "EVERYDAY", value: "everyday" },
        { text: "MONDAY", value: "monday" },
        { text: "TUESDAY", value: "tuesday" },
        { text: "WEDNESDAY", value: "wednesday" },
        { text: "THURSDAY", value: "thursday" },
        { text: "FRIDAY", value: "friday" },
        { text: "SATURDAY", value: "saturday" },
        { text: "SUNDAY", value: "sunday" },
      ],
      selectedDay: this.$dateFormat(now, "dddd").toLowerCase(),

      dateFromModal: false,
      dateToModal: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      timeDialog: false,
      actualTime: this.$dateFormat(now, "HH:mm"),

      timeout: 10000,
      snackbar: false,
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style>
</style>